const _ = require("lodash");
const fontSizeData = require("../../../shared/FontSizeData");

// This manages the sizing of the top container element of non-office pages.

// Constants in here need to be kept in sync with scripts/makeFontSizeCSS.js.

const MIN_HEIGHT = 600;
const ASPECT_RATIO = 4 / 3;
// Height of the page in CSS rem units, enforced by getRootFontSize.
const REM_HEIGHT = 75;

const getContainerSizeFromWindow = function(windowWidth, windowHeight) {
	const wWidth = windowWidth || window.innerWidth;
	const wHeight = windowHeight || window.innerHeight;
	let height = Math.min(wHeight, wWidth / ASPECT_RATIO);
	height = Math.max(height, MIN_HEIGHT);
	const width = height * ASPECT_RATIO;
	return {width, height};
};

const getDefaultContainerSize = function() {
	return getMinimumContainerSize();
};

const getMinimumContainerSize = function() {
	return {
		height: MIN_HEIGHT,
		width: MIN_HEIGHT * ASPECT_RATIO,
	};
};

const getContainerSizeFromWidth = function(width) {
	return {width, height: width / ASPECT_RATIO};
};

// Internal helper. Pass a function taking container width and height only.
// Returns a memoized version that uses the last result if the same container
// size is passed in.
const makeMemoizedSizeFunction = function(f) {
	let lastWidth = -1;
	let lastHeight = -1;
	let lastResult = null;
	return function(containerSize) {
		const {width, height} = containerSize;
		if (width !== lastWidth || height !== lastHeight) {
			lastWidth = width;
			lastHeight = height;
			lastResult = f(containerSize);
		}
		return lastResult;
	};
};

const getFontSizes = makeMemoizedSizeFunction(function(containerSize) {
	const {width, height} = containerSize;
	const baseFontSizes = _.mapValues(
		fontSizeData,
		([widthDivCoeff, minSize]) => {
			return Math.max(width / widthDivCoeff, minSize);
		}
	);
	return _.extend(baseFontSizes, {
		root: height / REM_HEIGHT,
	});
});

const getRootFontSize = makeMemoizedSizeFunction(function(containerSize) {
	const {height} = containerSize;
	return height / REM_HEIGHT;
});

const getShadowSizes = makeMemoizedSizeFunction(function(containerSize) {
	const {width} = containerSize;
	return {
		inset: width / 100,
		outset: width / 50,
		padding: width / 100, //Not for drawing use, but for adding padding to views to account for shadows
		button: width / 400,
	};
});

const getScrollbarSize = makeMemoizedSizeFunction(function(containerSize) {
	//TODO: This should maybe adjust based on the container size.
	return 20;
});

const getScrollGradientSize = makeMemoizedSizeFunction(function(containerSize) {
	const {width} = containerSize;
	return width / 80;
});

const getScreenWarning = function() {
	if (!global.window) return; // To pass tests
	const screen = global.window.screen;
	if (!screen) return;
	let warning;
	if (screen.height < MIN_HEIGHT || screen.width < MIN_HEIGHT * ASPECT_RATIO) {
		if (
			screen.height >= MIN_HEIGHT * ASPECT_RATIO &&
			screen.width >= MIN_HEIGHT &&
			(!global.window.orientation || global.window.orientation === 180)
		) {
			// iOS has orientation flag 0 or 180 for portrait
			// Samsung tablets do not have orientation
			warning = "rotate";
		} else if (
			screen.height >= MIN_HEIGHT * ASPECT_RATIO &&
			screen.width >= MIN_HEIGHT &&
			(global.window.orientation === 90 || global.window.orientation === -90)
		) {
			// iOS has orientation flag but the screen height/width don't change
			// when device is rotated.
			// This case should fit trainer, so no warning.
		} else {
			warning = "phone";
		}
	}
	return warning;
};

module.exports = {
	getContainerSizeFromWindow,
	getDefaultContainerSize,
	getMinimumContainerSize,
	getContainerSizeFromWidth,
	// Takes container size, caches if same one passed in consecutively
	getFontSizes,
	getRootFontSize,
	getShadowSizes,
	getScrollbarSize,
	getScrollGradientSize,
	getScreenWarning,
	MIN_HEIGHT,
	ASPECT_RATIO,
};
